module.exports = __webpack_public_path__ + "71771b5749a209c2f6160bf2e6233f02.svg";